<script setup lang="ts">
/**
 * The "need Claude" mark: a spark, at whatever size it is given.
 *
 * Deliberately NOT the terminal window the topbar's connect button uses. That
 * glyph means "here is how you plug Claude in", and it is drawn in the app's
 * own accent — the same blue as the selected row, the active tab and the today
 * column, so it reads as chrome. A flag someone raised on their own absence is
 * a different kind of thing and has to survive being scanned past, so it gets a
 * shape of its own and a colour (`--claude`) used nowhere else on the board.
 *
 * A spark rather than a flag or an exclamation: the point is who is wanted, not
 * how alarmed to be.
 */
defineProps<{ size?: number }>();
</script>

<template>
  <svg class="claude-mark" viewBox="0 0 16 16" :width="size ?? 11" :height="size ?? 11" aria-hidden="true">
    <path
      d="M8 1.3v13.4M1.3 8h13.4M4.1 4.1l7.8 7.8M11.9 4.1l-7.8 7.8"
      fill="none"
      stroke="currentColor"
      stroke-width="1.7"
      stroke-linecap="round"
    />
  </svg>
</template>
